<ng-container *ngIf="loading">
    <div class="loading-bar">
        <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
  </div>
  </ng-container>
  

<div class="container">
    <div class="card-container">
      <tm1-card variant = "shadow">
        <form id="editUser">
          <fieldset style="margin-bottom: 15px">
            <legend>Edit User</legend>
            <span>
              <tm1-text-field
                ngDefaultControl
                appearance="filled"
                inputsize="regular"
                label="Email"
                labelposition=""
                helplabel=""
                [(ngModel)]="email"
                (change)="onEmailChange($event)"
                type="email"
                value="{{ email }}"
                disabled=""
              ></tm1-text-field>
            </span>
            <br />
            <ng-container *ngIf="ticketmaster">
              <tm1-checkbox
                (change)="onVenueAdminChange($event)"
                size="small"
                label="venueAdmin"
                [checked]="toggleAdminCheckbox()"
                >Venue Admin
                <tm1-icon-tooltip icon="info" size="small" color="blue">
                  This means they will be able to manage users for their
                  primary venue
                </tm1-icon-tooltip>
              </tm1-checkbox>
            </ng-container>
            <br />
            <ng-container *ngIf="ticketmaster">
              <tm1-label>Users Organisation</tm1-label>
              <select (change)="onPrimaryVenueChange($event)" class="form-control">
                <option value="{{Selectedvenue}}">{{Selectedvenue}}</option>
                <option *ngFor="let venue of venuelist" [value]="venue.key"  >
                  {{ venue.value.name }}
                </option>
              </select>
            </ng-container>
            <tm1-label>Venues:</tm1-label>
            <ng-container *ngFor="let item of venuelist">
              <tm1-checkbox
                (change)="selectVenueChangeHandler($event, item)"
                size="small"
                [checked]="toggleVenueCheckBox(item)"
                >{{ item.value.name }}
              </tm1-checkbox>
            </ng-container>
            <br />
            <tm1-button
              variant="solid"
              style="width: max-content"
              (click)="editUser()"
              >Save</tm1-button
            >
            <br />
          </fieldset>
        </form>
      </tm1-card>
    </div>
  </div>